import { Component, ElementRef, ViewChild } from '@angular/core';
import { GenericModalService } from "../../service/generic-modal.service";
import { map, Observable } from "rxjs";
import { ModalType } from "../../interfaces/form-model";
import { SlDialog } from '@shoelace-style/shoelace';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent {

  @ViewChild("modal") model!: ElementRef<SlDialog>;

  constructor(private genericModalService: GenericModalService) { }

  /**
   * Observable to determine if the modal should be open
   */
  open$(): Observable<boolean> {
    return this.genericModalService.getModalContent$().pipe(
      map(content => content.type !== "HIDDEN")
    );
  }

  /**
   * Observable listener for the modal type for which content to be displayed
   */
  type$(): Observable<ModalType> {
    return this.genericModalService.getModalContent$().pipe(
      map(content => content.type)
    )
  }

  /**
   * Gets the current `data: any` of the modal state
   */
  getData(): any {
    return this.genericModalService.getModalContent().data;
  }

  /**
   * If the modal state has `preventClose` enabled, then the modal cannot be close
   * by clicking outside the modal area
   */
  preventClose(event: any): void {
    if (this.genericModalService.getModalContent().preventClose) {
      if (event.detail.source === 'overlay') {
        event.preventDefault();
      }
    }
  }

  /**
   * This sets the state in the GenericModalService to the default Hidden state once the
   * ShoeLace hide event is triggered
   */
  handleHide(): void {
    this.genericModalService.setModalHidden();
  }

  /**
   * calls the hide event on the ShoeLace modal to close it
   */
  closeModal(): void {
    this.model.nativeElement.hide();
  }
}
